let uniqueUploaderId = 0;

export class MarkdownFileUploader {
  constructor(cm, file) {
    uniqueUploaderId++;
    this.cm = cm;
    this.file = file;
    this.uniqueId = uniqueUploaderId;
  }

  start(uploadPromise) {
    const needsExtraNewline = this.initializeCursor();
    let newlines = needsExtraNewline ? '\n\n' : '\n';

    this.insertText = `![Uploading #${this.uniqueId}: ${this.file.name}]()`;

    this.cm.replaceSelection(newlines + this.insertText);
    const { line } = this.cm.getCursor();

    const progressBar = angular.element('<span></span>');
    const progressEl = angular.element(
      `<div class="markdown-file-upload-progress starting"></div>`,
    );
    progressEl.append(progressBar);
    const lineWidget = this.cm.addLineWidget(line, progressEl[0]);

    uploadPromise
      .then(
        (url) => {
          // success
          let desc = this.file.name;
          this.replaceInserted(`![${desc}](${url})`);
        },
        () => {
          // error
          this.replaceInserted('![Error Uploading Image]()');
        },
        (perc) => {
          // progress
          progressEl.removeClass('starting');
          progressBar.css({ width: 100 * perc + '%' });
        },
      )
      .finally(() => {
        // null out external references
        this.cm = this.file = null;
        progressEl.removeClass('starting');
        progressEl.addClass('closing');
        // eslint-disable-next-line angular/timeout-service
        setTimeout(() => lineWidget.clear(), 250);
      });
  }

  initializeCursor() {
    const cm = this.cm;
    const { line } = cm.getCursor();
    const selectedLine = cm.getLine(line);
    if (cm.getLine(line) !== '') {
      cm.setCursor({ line, ch: selectedLine.length });
    }
    return selectedLine.length > 0;
  }

  replaceInserted(value) {
    const cm = this.cm;
    cm.eachLine((lineHandle) => {
      let start = lineHandle.text.indexOf(this.insertText);
      if (start > -1) {
        let line = cm.getLineNumber(lineHandle);
        cm.replaceRange(
          value,
          { line, ch: start },
          { line, ch: start + this.insertText.length },
        );
        return true;
      }
    });
  }
}
